import Styles from "./styles.module.scss";
import ellowLogo from "../../assets/images/ellow-logo.svg";

function AuthHead() {

    return (
            <div className={Styles.header}> 
                <img src={ellowLogo} alt="ellow.io" width="95" height="26" />
            </div>
        );
    }
    
export default AuthHead;